var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FancySelect",
    _vm._g(
      {
        staticClass: "selector",
        attrs: {
          options: _vm.grants,
          loading: _vm.loading,
          value: _vm.value,
          label: "description",
          filterable: false,
          clearable: _vm.clearable,
          placeholder: "Select Grant"
        },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(grant) {
              return [
                _vm._v(" " + _vm._s(grant.description) + " "),
                _c("layoutText", { staticClass: "amount" }, [
                  _vm._v(
                    "Amount: " +
                      _vm._s(_vm.formatMoney(grant.amount, grant.currency))
                  )
                ])
              ]
            }
          }
        ])
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }